import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, Upload, message } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';

import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import { Urls } from 'kts-platform-frame/entry/constant';
import { reducers, MyStore } from 'kts-platform-frame/redux';
import ModulesFormAction from './Modules.Form.Action';

import moment from 'moment';

const Option = Select.Option;
const { TextArea } = Input;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    // validateFields(fieldNames: Array<string>, options: Object, callback: ValidateCallback): void;
}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    render() {
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 19 },
            },
        };
        const messageInfos = this.modulesState.messageInfos;

        return (
            <Form className={css.commonFormAdditional}>
                <Row>
                    <Col span={11}>
                        <Row>
                            <Col span={24}>
                                <FormItem
                                    {...formItemLayout}
                                    label="备注"
                                >
                                    {getFieldDecorator('Note', {
                                        initialValue: this.modulesState.forecastForm.Note,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^[^]{0,500}$/,
                                            //规则注释 message: '支持不超过500个字符',
                                            ...ModulesAction.getExtraRules('Note', false)
                                        }],
                                    })(
                                        <TextArea
                                            placeholder=""
                                            style={{ resize: 'none' }}
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'Note',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('Note'))}
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    {...formItemLayout}
                                    label="附件"
                                >
                                    {getFieldDecorator('upload', {
                                        initialValue: undefined,
                                        rules: [],
                                    })(
                                        <Upload {...ModulesAction.uploadSet()} fileList={this.modulesState.uploadList}>
                                            <Button>
                                                上传附件
                                            </Button>
                                        <span className={css.uploadTip} onClick={e => e.stopPropagation()}>支持不超过5M的文件</span>
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={11} offset={1}>
                        <Row>
                            <Col span={24}>
                                {ModulesAction.getExtraTemplate(this.modulesState.forecastForm, form, formItemLayout, false)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        );
    }

}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.ForecastFormAdditional.tsx